import { useAppLoader } from './AppLoader'
import { useAppSnackbar } from './AppSnackbar'

export const useApiError = () => {
    const { hide: hideLoader } = useAppLoader()
    const { show: showSnack } = useAppSnackbar()

    const handleError = (message = null, duration = 5000, hide = true) => {
        message = (message) ? message : 'ERROR on loading from API'

        if (hide) hideLoader()
        showSnack(message, 'error', duration)
    }

    return { handleError }
}